import isEmpty from 'lodash/isEmpty';
import API from './../api';

export default {

    namespaced: true,

    state() {
        return {
            guestList: [],
            reservationDetails: {},
            reservationInvoice: null,
            reservationMetadata: {},
            busy: false,
        };
    },

    getters: {
        guestList: (state) => state.guestList,
        reservationDetails: (state) => state.reservationDetails,
        reservationInvoice: (state) => state.reservationInvoice,
        reservationMetadata: (state) => state.reservationMetadata,
        busy: (state) => state.busy,
    },

    mutations: {
        gotGuestList(state, response) {
            state.guestList = response.data || [];
        },
        resetGuestList(state, response) {
            state.guestList = [];
        },        
        gotReservationDetails(state, response) {
            state.reservationDetails = response.data;
        },
        updatedReservationDetails(state, response) {
            state.reservationDetails = response.data;
        },
        resetReservationDetails(state) {
            state.reservationDetails = {
                'full_name': '',
                'first_name': '',
            };
        },
        setReservationDetails(state, { values }) {
            state.reservationDetails = values;
        },
        gotReservationMetadata(state, response) {
            state.reservationMetadata = response.data || {};
        },
        gotReservationInvoice(state, response) {
            state.reservationInvoice = response.data;
        },
        updatedReservationInvoice(state, response) {
            state.reservationInvoice = response.data;
        },
        resetReservationInvoice(state) {
            state.reservationInvoice = null;
        },
        setBusy(state, value) {
            state.busy = value;
        }
    },

    actions: {
        async fetchGuestList({ commit }, { first_name, last_name, email }) {
            commit('gotGuestList', await API.get(`/app/reservation/details/guest-list/?first_name=${first_name}&last_name=${last_name}&email=${email}`));
        },
        async fetchReservationMetadata({ commit }, { id }) {
            commit('gotReservationMetadata', await API.get(`/app/reservation/metadata/${id}/`));
        },
        resetGuestList({ commit }) {
            commit('resetGuestList');
        },
        async fetchReservationDetails({ commit }, { id }) {
            commit('gotReservationDetails', await API.get(`/app/reservation/details/${id}/`));
        },
        async createReservationDetails({ commit }, payload) {
            const response = await API.post(`/app/reservation/details/`, payload);
            return response.data;
        },
        async updateReservationDetails({ commit }, { id, ...payload }) {
            commit(
                'updatedReservationDetails',
                await API.patch(`/app/reservation/details/${id}/`, payload)
            );
        },        
        setReservationDetails({ commit }, { values }) {
            commit('setReservationDetails', { values });
        },        
        async fetchReservationInvoice({ commit }, { id }) {
            commit('gotReservationInvoice', await API.get(`/app/reservation/invoice/${id}/`));
        },
        async createReservationInvoice({ commit }, payload) {
            const response = await API.post(`/app/reservation/invoice/`, payload);
            return response.data;
        },
        async updateReservationInvoice({ commit }, { id, ...payload }) {
            commit(
                'updatedReservationInvoice',
                await API.patch(`/app/reservation/invoice/${id}/`, payload)
            );
        },        
    },

};
